import * as Kit from "@washingtonpost/wpds-theme";

export const Box = Kit.styled("div");

type BoxProps = React.ComponentPropsWithRef<typeof Box>;

export type { BoxProps };
